import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';

@Component({
  selector: 'lib-web-shared-ui-terms-and-condition',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './lib-terms-and-policy.component.html',
  styleUrl: './lib-terms-and-policy.component.scss',
})
export class LibTermsAndConditionComponent {
  @Input() set data(value: ITermsAndPolicyEntity[]) {
    this.dataSignal.set(value);
  }

  dataSignal = signal<ITermsAndPolicyEntity[]>([]);
}
